export default {
  clearLoginStore (context, payload) {
    context.commit('CLEAR_LOGIN_STORE', payload)
  },
  changeLogged (context, payload) {
    context.commit('CHANGE_LOGGED', payload)
  },
}
